import { Component } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AbstractWidgetComponent, ContextChange, DialogService, HttpService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { ArticleTypeService } from 'src/erp-articles/article-types/article-type.service';
import { ProjectAdminContext } from '../../project.model';

@Component({
  selector: 'app-project-admin',
  templateUrl: './project-admin.component.html',
  styleUrls: ['./project-admin.component.scss']
})
export class ProjectAdminComponent extends AbstractWidgetComponent {

  projectAdminContext = new ProjectAdminContext();

  constructor(
    public translationService: TranslationService,
    private matDialog: MatDialog,
    private articleTypeService: ArticleTypeService,
    private http: HttpService,
    private dialogService: DialogService
  ) {
    super();
  }


  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    this.projectAdminContext.widgetIdentifier = this.widgetIdentifier;
    this.projectAdminContext.contextReady.next();
  }
}
